import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

// Strict email pattern that only allows A-Z, a-z, 0-9, and specific special characters (., _, -, +)
export const EMAIL_PATTERN = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const email = (control.value || '').trim();

  if (!email) {
    return { required: true };
  }

  // 1. Basic length checks
  if (email.length > 254) return { emailPattern: true };

  // 2. Check for consecutive special characters manually for better error messaging
  if (email.includes('..') || email.includes('--') || email.includes('.-') || email.includes('-.')) {
    return { invalidConsecutiveChars: true };
  }

  // 3. Split and check parts
  const parts = email.split('@');
  if (parts.length !== 2) return { emailPattern: true };

  const localPart = parts[0];
  const domainPart = parts[1];

  // 4. Local part cannot start or end with a dot
  if (localPart.startsWith('.') || localPart.endsWith('.')) {
    return { localPartInvalid: true };
  }

  // 5. Check overall pattern with strict regex
  if (!EMAIL_PATTERN.test(email)) {
    return { emailPattern: true };
  }

  // 6. Domain part detailed checks
  const domainLabels = domainPart.split('.');
  if (domainLabels.length < 2) return { emailPattern: true };
  
  for (const label of domainLabels) {
    if (!label) return { emailPattern: true }; 
    if (label.startsWith('-') || label.endsWith('-')) {
      return { domainLabelInvalid: true };
    }
  }

  return null;
}

@Directive({
  selector: '[appEmailValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: EmailValidatorDirective,
    multi: true
  }],
  standalone: true
})
export class EmailValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return emailValidator(control);
  }
}
